"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const traverse = (models, modelId, options, output) => {
    const model = models[modelId];
    if (options.onlyTerms &&
        ((!model.name && (!model.children || !model.children.length)) ||
            model[constants_1.MODEL_TYPE] === 'flags' ||
            model[constants_1.MODEL_TYPE] === 'basecriteria')) {
        return output;
    }
    const trueValue = model.value === undefined ? model[constants_1.MODEL_CONTENTS] : model.value;
    const trueName = model.name || (trueValue !== undefined ? model[constants_1.MODEL_TYPE] : undefined);
    if (model.children) {
        for (let x = 0; x < model.children.length; x += 1) {
            traverse(models, model.children[x], options, output);
        }
    }
    if (!trueName)
        return output;
    output.values[trueName] = trueValue || '';
    if (!model.meta)
        return output;
    if (trueValue !== model.meta.initialValue) {
        output.changed.push(trueName);
    }
    const visible = model.meta.display !== false &&
        (model.meta.groupModelIds
            ? model.meta.groupModelIds.every(g => models[g.id].meta ? models[g.id].meta.display !== false : true)
            : true);
    const invalid = visible &&
        trueValue &&
        model.meta.validationErrors &&
        model.meta.validationErrors.length > 0;
    output.isValid = output.isValid && !invalid;
    if (invalid) {
        output.invalidModels.push({ model, modelId });
    }
    return output;
};
exports.default = ({ model, modelId, options = {} }) => traverse(model, modelId, options, {
    values: {},
    isValid: true,
    invalidModels: [],
    changed: [],
});
//# sourceMappingURL=traverse-model-values.js.map